import def from './define-action'

const INITIAL_STATE = {
    pois: {
        samplePoiId: {
            saving   : false,
            saveError: '', // error details from last save attempt
        },
    },
}

// =====================================================================================================================
// Action Constants
// =====================================================================================================================

const ActionConstants = {
    BEGIN_CREATE_POI   : 'BEGIN_CREATE_POI',
    BEGIN_SAVE_POI     : 'BEGIN_SAVE_POI',
    SAVE_POI_SUCCESS   : 'SAVE_POI_SUCCESS',
    CREATE_POI_SUCCESS : 'CREATE_POI_SUCCESS',
}

// =====================================================================================================================
// Actions
// =====================================================================================================================

const Actions = {
    beginCreatePoi   : def(ActionConstants.BEGIN_CREATE_POI, 'venueId'),
    beginSavePoi     : def(ActionConstants.BEGIN_SAVE_POI, 'venueId', 'uuid'),
    savePoiSuccess   : def(ActionConstants.SAVE_POI_SUCCESS, 'uuid', 'data'),
    createPoiSuccess : def(ActionConstants.CREATE_POI_SUCCESS, 'venueId'),
}

// =====================================================================================================================
// Reducer
// =====================================================================================================================

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case ActionConstants.BEGIN_CREATE_POI:   return beginEndPoiSave(state, 'NEW', true)
    case ActionConstants.BEGIN_SAVE_POI:     return beginEndPoiSave(state, action.uuid, true)
    case ActionConstants.SAVE_POI_SUCCESS:   return beginEndPoiSave(state, action.uuid, false)
    case ActionConstants.CREATE_POI_SUCCESS: return beginEndPoiSave(state, 'NEW', false)
    default:                         return state
    }
}

function beginEndPoiSave(state, uuid, isSaving) {
    return {
        ...state,
        pois: {
            ...state.pois,
            [uuid]: { saving: isSaving },
        },
    }
}

export default reducer

export {
    reducer,
    Actions,
    ActionConstants,
}
